const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/privacy-policy", "/privacy-policy"],
    exact: true,
    component: "privacy-policy",
  },
];

export default routes;
